<template>
  <div>
    <a
      href="#"
      style="top: 3px; position: relative; padding: 20px 12px 20px 20px; color: white"
      @click="openDrawer()"
    >
      <wa-icon library="bootstrap" name="list" style="font-size: 26px" />
    </a>
    <wa-drawer
      light-dismiss
      ref="drawer"
      class="drawer-menu"
      placement="start"
      style="--size: 360px; color: var(--color--black)"
    >
      <nav>
        <div class="menu-section">
          <h2 class="menu-section__title">{{ $t('sidebar.sections.sell') }}</h2>
          <ul>
            <li>
              <RouterLink to="/"
                ><wa-icon library="bootstrap" name="eyeglasses"></wa-icon
                >{{ $t('sidebar.products') }}</RouterLink
              >
            </li>
            <li v-if="!deviceStore.isInternalStore">
              <RouterLink to="/appointments"
                ><wa-icon library="bootstrap" name="calendar-week"></wa-icon
                >{{ $t('sidebar.appointments') }}</RouterLink
              >
            </li>
            <li v-if="!deviceStore.isInternalStore" v-access:promotions>
              <RouterLink to="/promotions"
                ><wa-icon library="bootstrap" name="percent"></wa-icon
                >{{ $t('sidebar.promotions') }}</RouterLink
              >
            </li>
            <li v-if="!deviceStore.isInternalStore">
              <RouterLink to="/day-overview"
                ><wa-icon library="bootstrap" name="cash-coin"></wa-icon
                >{{ $t('sidebar.day_overview') }}</RouterLink
              >
            </li>
          </ul>
        </div>

        <div class="menu-section">
          <h2 class="menu-section__title">{{ $t('sidebar.sections.stock') }}</h2>
          <ul>
            <li v-if="!deviceStore.isInternalStore">
              <RouterLink
                :to="{
                  name: 'workbench'
                }"
                ><wa-icon library="bootstrap" name="controller"></wa-icon
                >{{ $t('sidebar.workbench') }}</RouterLink
              >
            </li>
            <li>
              <RouterLink
                :to="{
                  name: 'incoming-goods'
                }"
                ><wa-icon library="bootstrap" name="box-arrow-in-down"></wa-icon
                >{{ $t('sidebar.incoming_stock_transfers') }}</RouterLink
              >
            </li>
            <li>
              <RouterLink
                :to="{
                  name: 'outgoing-stock-transfers'
                }"
                ><wa-icon library="bootstrap" name="box-arrow-up"></wa-icon
                >{{ $t('sidebar.outgoing_stock_transfers') }}</RouterLink
              >
            </li>
            <li v-access:stockManagement>
              <RouterLink to="/stock-management"
                ><wa-icon library="bootstrap" name="box-seam"></wa-icon
                >{{ $t('sidebar.stock_management') }}</RouterLink
              >
            </li>
          </ul>
        </div>

        <div
          v-if="deviceStore.settings.mode === 'STORE' && !deviceStore.isInternalStore"
          class="menu-section"
        >
          <h2 class="menu-section__title">{{ $t('sidebar.sections.reporting') }}</h2>
          <ul>
            <li>
              <RouterLink to="/reports"
                ><wa-icon library="bootstrap" name="graph-up"></wa-icon
                >{{ $t('sidebar.reports_and_analytics') }}</RouterLink
              >
            </li>
          </ul>
        </div>

        <div v-if="!deviceStore.isInternalStore" class="menu-section">
          <h2 class="menu-section__title">{{ $t('sidebar.sections.admin') }}</h2>
          <ul>
            <li>
              <RouterLink to="/terminal-management"
                ><wa-icon library="bootstrap" name="calculator"></wa-icon
                >{{ $t('sidebar.terminal_management') }}</RouterLink
              >
            </li>
            <li v-access:giftCards>
              <RouterLink to="/gift-cards-management"
                ><wa-icon library="bootstrap" name="postcard-heart"></wa-icon
                >{{ $t('sidebar.gift_cards_management') }}</RouterLink
              >
            </li>
            <li v-access:taskExecutionMenu>
              <RouterLink to="/task-execution"
                ><wa-icon library="bootstrap" name="list-task"></wa-icon
                >{{ $t('sidebar.task_execution') }}</RouterLink
              >
            </li>
            <li v-access:prestaOrders>
              <RouterLink :to="{ name: 'presta-orders' }"
                ><wa-icon library="bootstrap" name="archive"></wa-icon
                >{{ $t('sidebar.presta_orders') }}</RouterLink
              >
            </li>
            <li v-access:consumables>
              <RouterLink to="/consumables"
                ><wa-icon library="bootstrap" name="cup-straw"></wa-icon
                >{{ $t('sidebar.consumables') }}</RouterLink
              >
            </li>
            <li v-access:scmCallbacks>
              <RouterLink :to="{ name: 'callbacks' }"
                ><wa-icon library="bootstrap" name="arrow-repeat"></wa-icon
                >{{ $t('sidebar.callbacks') }}</RouterLink
              >
            </li>
          </ul>
        </div>
      </nav>

      <div slot="footer" style="text-align: left">
        <wa-select id="locale" v-model="locale" size="s" @change="handleLocalChange">
          <wa-icon library="bootstrap" slot="start" name="translate"></wa-icon>
          <wa-option v-for="(loc, index) in $i18n.availableLocales" :key="index" :value="loc">
            {{ languages[loc] }}
          </wa-option>
        </wa-select>

        <wa-button
          variant="neutral"
          appearance="outlined"
          size="s"
          style="width: 100%; margin-top: var(--wa-space-s)"
          @click="isResetAppSettingsDialogOpen = true"
        >
          <PhArrowsCounterClockwise slot="start" :size="20" />
          {{ $t('sidebar.reset_app_settings') }}
        </wa-button>
        <wa-button
          variant="neutral"
          appearance="outlined"
          size="s"
          style="width: 100%; margin-top: var(--wa-space-s)"
          @click="openSettingsDialog()"
        >
          <wa-icon library="bootstrap" slot="start" name="shop"></wa-icon>
          <span
            >{{ $t('sidebar.store') }}: {{ deviceStore.settings.warehouse }}
            <wa-badge v-if="deviceStore.settings.assemblyOnlyInServiceHub" variant="neutral">{{
              $t('globals.assemplyInSH')
            }}</wa-badge></span
          >
        </wa-button>

        <wa-button
          variant="neutral"
          appearance="outlined"
          size="s"
          style="width: 100%; margin-top: var(--wa-space-s)"
          @click="signOut()"
        >
          <wa-icon library="bootstrap" slot="start" name="box-arrow-right"></wa-icon>
          {{ $t('globals.logout') }}
        </wa-button>
        <div style="text-align: left; opacity: 0.4; line-height: 1.3">
          <small> {{ $t('sidebar.app_version') }}: {{ v }}</small>
        </div>
      </div>
    </wa-drawer>

    <wa-dialog
      light-dismiss
      :open="isResetAppSettingsDialogOpen"
      class="promptDialog"
      :label="$t('menu.dialog.reset_app_settings.title')"
      @wa-request-close="isResetAppSettingsDialogOpen = false"
    >
      <div class="reset-app-wrapper">
        <p>{{ $t('menu.dialog.reset_app_settings.subtitle') }}</p>
        <div class="reset-app-wrapper__options">
          <wa-switch
            :checked="areDeviceSettingsChecked"
            size="m"
            @change="areDeviceSettingsChecked = !areDeviceSettingsChecked"
            >{{ $t('menu.dialog.reset_app_settings.toggle.device_settings') }}</wa-switch
          >
          <wa-switch
            :checked="areLastCustomerChecked"
            size="m"
            @change="areLastCustomerChecked = !areLastCustomerChecked"
            >{{ $t('menu.dialog.reset_app_settings.toggle.last_used_customers') }}</wa-switch
          >
          <wa-switch
            :checked="areAllSettingsChecked"
            size="m"
            @change="handleResetAllSettingsChange"
            >{{ $t('menu.dialog.reset_app_settings.toggle.reset_all_settings') }}</wa-switch
          >
          <small
            v-if="areAllSettingsChecked"
            style="color: var(--color--warning); margin-top: -8px"
          >
            {{ $t('menu.dialog.reset_app_settings.hint.reset_all_settings') }}
          </small>
        </div>
      </div>

      <wa-button
        slot="footer"
        variant="neutral"
        appearance="outlined"
        @click="isResetAppSettingsDialogOpen = false"
      >
        {{ $t('globals.cancel') }}</wa-button
      >
      <wa-button
        slot="footer"
        :disabled="isButtonDisabled"
        variant="brand"
        @click="handleAppReset"
        >{{ $t('globals.confirm') }}</wa-button
      >
    </wa-dialog>
  </div>
</template>

<script setup>
import { useDeviceStore } from '@/stores/device'
import { computed, inject, onBeforeMount, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import '@awesome.me/webawesome/dist/components/badge/badge.js'
import '@awesome.me/webawesome/dist/components/button/button.js'
import '@awesome.me/webawesome/dist/components/dialog/dialog.js'
import '@awesome.me/webawesome/dist/components/drawer/drawer.js'
import '@awesome.me/webawesome/dist/components/dropdown/dropdown.js'
import '@awesome.me/webawesome/dist/components/icon/icon.js'
import '@awesome.me/webawesome/dist/components/dropdown-item/dropdown-item.js'
import '@awesome.me/webawesome/dist/components/option/option.js'
import '@awesome.me/webawesome/dist/components/select/select.js'
import '@awesome.me/webawesome/dist/components/switch/switch.js'
import '@awesome.me/webawesome/dist/components/tree/tree.js'
import '@awesome.me/webawesome/dist/components/tree-item/tree-item.js'

import { useNotification } from '@/composables/useNotification.js'
import { useCustomerStore } from '@/stores/customer.js'
import { useUiStore } from '@/stores/ui'
import { PhArrowsCounterClockwise } from '@phosphor-icons/vue'
import { RouterLink } from 'vue-router'
import { hideElement } from '@/utils/webawesome.js'

const notification = useNotification()
const supabase = inject('supabase')
const deviceStore = useDeviceStore()
const customerStore = useCustomerStore()
const drawer = ref()
const { locale } = useI18n()
const uiStore = useUiStore()
const isResetAppSettingsDialogOpen = ref(false)
const areDeviceSettingsChecked = ref(false)
const areLastCustomerChecked = ref(false)
const areAllSettingsChecked = ref(false)
const currentCart = customerStore.getCurrentCart

const isButtonDisabled = computed(() => {
  return !(
    areLastCustomerChecked.value ||
    areDeviceSettingsChecked.value ||
    areAllSettingsChecked.value
  )
})

// eslint-disable-next-line no-undef
const v = __APP_VERSION__
const route = useRoute()
const languages = {
  de: 'Deutsch',
  ch_de: 'Deutsch (Schweiz)',
  en: 'English',
  fr: 'Français'
}

onBeforeMount(() => {
  locale.value =
    deviceStore.settings.country === 'ch' && deviceStore.settings.language === 'de'
      ? 'ch_de'
      : deviceStore.settings.language
})

function openDrawer() {
  uiStore.showCart = false
  drawer.value.open = true
}

async function signOut() {
  sessionStorage.clear() // clear session storage on sign out -> removes commercelayer token and force to fetch a new one on next login
  await supabase.auth.signOut()
}

watch(
  () => route.name,
  () => {
    hideElement(drawer.value)
  }
)

function openSettingsDialog() {
  localStorage.removeItem('marketSettings')
  uiStore.showDeviceMarketSettingsDialog = true
  customerStore.customer = {}
  customerStore.setCurrentCart(null)
}

function handleLocalChange(event) {
  locale.value = event.target.value
  updateLanguageInTheLocalStorage(locale.value === 'ch_de' ? 'de' : locale.value)
  deviceStore.settings.language = locale.value === 'ch_de' ? 'de' : locale.value
}

function updateLanguageInTheLocalStorage(lang) {
  const marketSettings = localStorage.getItem('marketSettings')
  const parsedMarketSettings = JSON.parse(marketSettings)

  parsedMarketSettings.language = lang
  localStorage.setItem('marketSettings', JSON.stringify(parsedMarketSettings))
}

function clearAllCookies() {
  const cookies = document.cookie.split(';')
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i]
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim()
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`
  }
}

function handleResetAllSettingsChange() {
  areAllSettingsChecked.value = !areAllSettingsChecked.value
  if (areAllSettingsChecked.value) {
    areDeviceSettingsChecked.value = true
    areLastCustomerChecked.value = true
  } else {
    areDeviceSettingsChecked.value = false
    areLastCustomerChecked.value = false
  }
}

async function handleAppReset() {
  if (areLastCustomerChecked.value) {
    localStorage.removeItem('customerList')
    areLastCustomerChecked.value = false
  }

  if (areDeviceSettingsChecked.value) {
    localStorage.removeItem('marketSettings')
  }

  if (currentCart?.value?.id && areDeviceSettingsChecked.value) {
    customerStore.setCurrentCart(null)
  }

  if (areAllSettingsChecked.value) {
    localStorage.clear()
    sessionStorage.clear()
    clearAllCookies()
    areAllSettingsChecked.value = false
    isResetAppSettingsDialogOpen.value = false
    await signOut()
    return
  }

  isResetAppSettingsDialogOpen.value = false

  if (!areDeviceSettingsChecked.value) {
    notification.showNotification({ message: 'Your settings have been updated successfully.' })
  }

  if (areDeviceSettingsChecked.value) {
    uiStore.showDeviceMarketSettingsDialog = true
    areDeviceSettingsChecked.value = false
  }
}
</script>
<style src="@/components/Layout/Header/Menu.css" scoped></style>
